import { BehaviorSubject } from 'rxjs';
var NotiService = /** @class */ (function () {
    function NotiService() {
        this.messageSource = new BehaviorSubject("th");
        this.message = this.messageSource.asObservable();
    }
    NotiService.prototype.langChange = function (_lang) {
        this.messageSource.next(_lang);
    };
    return NotiService;
}());
export { NotiService };



// WEBPACK FOOTER //
// ./src/app/noti.service.ts.pre-build-optimizer.js